/*
 * @Author: Zhouqi
 * @Date: 2025-12-12 12:10:00
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-12 14:05:00
 */

const VideoGenerationSkeleton = () => {
  return (
    <div className="relative flex p-[16px] h-full bg-[#f7f7f7] box-border overflow-hidden">
      {/* 左侧操作面板 */}
      <div className="w-[328px] relative bg-[#ffffff] rounded-[8px] overflow-x-hidden flex flex-col">
        {/* Tab 切换区域 */}
        <div className="p-[24px] border-b border-gray-200">
          <div className="flex gap-[12px]">
            {[...Array(2)].map((_, index) => (
              <div
                key={index}
                className="relative h-[36px] bg-gray-200 rounded-[6px] flex-1 overflow-hidden"
              >
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            ))}
          </div>
        </div>

        {/* 表单区域 */}
        <div className="flex-1 p-[24px] overflow-auto">
          <div className="flex flex-col gap-[24px]">
            {/* 输入框骨架 */}
            {[...Array(3)].map((_, index) => (
              <div key={index} className="flex flex-col gap-[8px]">
                <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[80px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
                <div className="relative h-[40px] bg-gray-200 rounded-[6px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
              </div>
            ))}

            {/* 大文本框骨架 */}
            <div className="flex flex-col gap-[8px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[100px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              <div className="relative h-[120px] bg-gray-200 rounded-[6px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>
          </div>
        </div>

        {/* 底部按钮区域 */}
        <div className="p-[24px] border-t border-gray-200">
          <div className="relative h-[44px] bg-gray-200 rounded-[6px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>
      </div>

      {/* 右侧任务面板 */}
      <div className="flex-1 ml-[16px] relative bg-[#ffffff] rounded-[8px] overflow-x-hidden flex flex-col p-[24px]">
        {/* 任务列表标题 */}
        <div className="mb-[16px]">
          <div className="relative h-[20px] bg-gray-200 rounded-[4px] max-w-[120px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>

        {/* 任务列表骨架 */}
        <div className="flex flex-col gap-[16px]">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="relative h-[120px] bg-gray-200 rounded-[8px] overflow-hidden"
            >
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default VideoGenerationSkeleton;
